import React from 'react'
import './index.scss'
import { Row, Col, Layout, Table, Button, Input, message, Modal, Tabs, Tag, Pagination } from 'antd'
import { ExclamationCircleOutlined, FileAddOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import AddModal from './modals/add'
import EditModal from './modals/edit'
import { connect } from 'react-redux'
import { loadCommendation, deleteCommendation, updateCommendation, loadSelectedRowCommendation } from '../actions'
import { getParamFromUrl } from '../../../../utilities/helper'
import Papa from 'papaparse'
import moment from 'moment'
import { getUser } from '../../../../utilities/token'
import {
  APPROVAL,
  APPROVED,
  CANCELLED,
  REJECTED
} from '../../../../utilities/serviceStatusEnum'
const { Search } = Input;
const { TabPane } = Tabs;

class Commendations extends React.Component {
  constructor() {
    super()
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      commendationStatus: '0',
      //pagination
      page: 1,
      limit: 10,
      searchTerm: '',

      selectedRow: {},
      selectedRowKeys: [],
      downloadLoading: false,
      tableData: []
    }
    this.addModalToggle = this.addModalToggle.bind(this)
    this.editModalToggle = this.editModalToggle.bind(this)
    this.timeout = 0;
  }

  componentWillReceiveProps(nextProps) {
    const { limit, searchTerm, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }

    if ((this.props.commendationSuccess !== nextProps.commendationSuccess) && nextProps.commendationSuccess) {
      this.setState({ isAddModalOpen: false })
      message.success("Commendation added successfully.")
      this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)
    }
    if ((this.props.updateCommendationSuccess !== nextProps.updateCommendationSuccess) && nextProps.updateCommendationSuccess) {
      this.setState({ isEditModalOpen: false })
      message.success("Commendation edited successfully.")
      this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)
    }
    if ((this.props.deleteCommendationSuccess !== nextProps.deleteCommendationSuccess) && nextProps.deleteCommendationSuccess) {
      this.setState({ isEditModalOpen: false })
      message.success("Commendation deleted successfully.")
      this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)
    }
    if ((this.props.commendationsSuccess !== nextProps.commendationsSuccess) && nextProps.commendationsSuccess) {
      this.setState({ tableData: nextProps.commendationsData.data })
    }
  }

  componentDidMount() {
    const { limit, searchTerm, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }

    this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)

    if (getParamFromUrl('modal') === 'true') {
      this.setState({ isEditModalOpen: true })
    }

    window.Echo.channel(`admin-commendations-crud.${getUser().id}`)
      .listen('.admin-commendations-crud-channel', (response) => {
        const { data } = response
        const index = this.state.tableData.findIndex(item => item.id === data.id)
        if (data.status === 0) {
          this.state.tableData.splice(index, 1) // delete
        } else {
          if (index !== -1) this.state.tableData[index] = data // update
          else {
            this.state.tableData.unshift({ ...data }) // create
            this.state.tableData = this.state.tableData.slice(0, this.state.limit) // re-assigning and limit to 10
          }
        }
        // this.setState({tableData: this.state.tableData})
        // this.setState are not working inside echo channel, 
        // regarding to this. <Table key/> key must be unique to know if there was a changed.
        this.forceUpdate()
      })

  }

  getKeyConvertToStatus(key) {
    let status
    switch (key) {
      case '0':
        status = ''
        break;
      case '1':
        status = APPROVAL
        break;
      case '2':
        status = APPROVED
        break;
      case '3':
        status = CANCELLED
        break;
      case '4':
        status = REJECTED
        break;
      default:
        break;
    }
    return status
  }

  addModalToggle() {
    this.setState({ isAddModalOpen: !this.state.isAddModalOpen })
  }

  editModalToggle() {
    this.setState({ isEditModalOpen: !this.state.isEditModalOpen })
  }

  handleDeleteCommendation(id) {
    const self = this
    Modal.confirm({
      title: 'Do you want to delete this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'You cannot undo this.',
      onOk() {
        self.props.onDeleteCommendation(id)
      },
      onCancel() { },
    });
  }

  handleSearch(searchTerm) {
    const { limit, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)

    }, 1000);
    this.setState({ searchTerm: searchTerm })
  }

  onChangePagination(page, limit) {
    const { searchTerm } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }
    this.props.onLoadCommendation(this.getKeyConvertToStatus(this.state.commendationStatus), pagination)
    this.setState({ page, limit })
  }

  getStatus(status) {
    switch (status) {
      case 1:
        return <Tag color="gold">FOR APPROVAL</Tag>
      case 2:
        return <Tag color="lime">APPROVED</Tag>
      case 3:
        return <Tag color="geekblue">ONGOING</Tag>
      case 4:
        return <Tag color="green">COMPLETED</Tag>
      case 5:
        return <Tag color="magenta">CANCELLED</Tag>
      case 6:
        return <Tag color="red">REJECTED</Tag>
      default:
        break;
    }
  }

  getType(type) {
    switch (type) {
      case 1:
        return <Tag color="#2db7f5">COMMENDATION</Tag>
      case 2:
        return <Tag color="#108ee9">TESTIMONIAL</Tag>
      default:
        break;
    }
  }

  getTypeForCsv(type) {
    switch (type) {
      case 1:
        return 'COMMENDATION'
      case 2:
        return 'TESTIMONIAL'
      default:
        break;
    }
  }

  access(title, role) {
    if (this.props.adminData.roles.length === 0) return false
    const found = this.props.adminData.roles.find(data => data.title === title)
    if (found !== -1) return (found.roles[role]) ? true : false
    else return false
  }

  handleCommendationStatus(e) {
    const { limit, searchTerm, page } = this.state
    const pagination = {
      page: 1,
      limit: limit,
      searchTerm: searchTerm
    }

    this.setState({ permitStatus: e.toString(), page: 1 })
    this.props.onLoadCommendation(this.getKeyConvertToStatus(e), pagination)
  }


  handleDownloadSelectedRowToCSV() {
    this.setState({ downloadLoading: true })
    this.props.onLoadSelectedRowCommendation(this.state.selectedRowKeys).then(res => {

      const newData = res.payload.map(data => {
        return {
          id: data.id,
          ticketNumber: data.ticketNumber,
          clientCode: data.tenant && data.tenant.clientCode,
          clientName: data.tenant && data.tenant.uoccname,
          title: data.title,
          type: this.getTypeForCsv(data.type),
          status: this.getStatusForCsv(data.status),
          remarks: data.remarks,
          comment: data.comment,
          createdAt: moment(data.created_at).format('DD/MM/YYYY'),
        }
      })
      var csv = Papa.unparse(newData);

      var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, 'Commendation And Testimonial Reports.csv');
      }
      else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', 'Commendation And Testimonial Reports.csv');
      tempLink.click();

    }).finally(() => {
      this.setState({ downloadLoading: false })
    })
  }

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  getStatusForCsv(status) {
    switch (status) {
      case 1:
        return 'FOR APPROVAL'
      case 2:
        return 'APPROVED'
      case 3:
        return 'ONGOING'
      case 4:
        return 'COMPLETED'
      case 5:
        return 'CANCELLED'
      case 6:
        return 'REJECTED'
      default:
        break;
    }
  }


  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      preserveSelectedRowKeys: true
    };
    const dataSource = this.state.tableData

    const columns = [
      {
        title: 'Service Ticket #',
        dataIndex: 'ticketNumber',
        key: 'ticketNumber',
        sorter: (a, b) => a.ticketNumber && a.ticketNumber.localeCompare(b.ticketNumber)
      },
      {
        title: 'Client Code',
        dataIndex: 'tenant',
        key: 'clientCode',
        sorter: (a, b) => a.tenant.clientCode && a.tenant.clientCode.localeCompare(b.tenant && b.tenant.clientCode),
        render: (info, data) => {
          return (
            <span>{data.tenant && `${data.tenant.clientCode}`}</span>
          )
        }
      },
      {
        title: 'Client Name',
        dataIndex: 'tenant',
        key: 'tenant',
        sorter: (a, b) => a.tenant.uoccname && a.tenant.uoccname.localeCompare(b.tenant && b.tenant.uoccname),
        render: (info, data) => {
          return (
            <span>{data.tenant && `${data.tenant.uoccname}`}</span>
          )
        }
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        sorter: (a, b) => a.title && a.title.localeCompare(b.title),
      },
      {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        sorter: (a, b) => a.comment && a.comment.localeCompare(b.comment),
        width: 350
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (item) => {
          return (<span>{this.getType(item)}</span>)
        }
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (item) => {
          return (<span>{this.getStatus(item)}</span>)
        }
      },

      {
        title: 'Actions',
        dataIndex: 'actions',
        key: '',
        render: (info, data) => {
          return (
            <div className='action-btn'>
              {
                this.access('commendations', 'view') &&
                <Button type="primary" icon={<EditOutlined />} size={'medium'} title='View' onClick={() => this.setState({ selectedRow: data, isEditModalOpen: true })} >View</Button>
              }
              {
                this.access('commendations', 'delete') &&
                <Button type="primary" icon={<DeleteOutlined />} size={'medium'} title='Delete' danger onClick={() => this.handleDeleteCommendation(data.id)}  >Delete</Button>
              }
            </div>
          )
        }
      },
    ];
    return (
      <Layout className='commendations-container'>

        <Layout.Content>
          <div className='commendation-title'>
            <h1>Commendations And Testimonials</h1>
          </div>
          <Tabs defaultActiveKey="0" type="card" size='small' onChange={e => this.handleCommendationStatus(e)}>
            <TabPane tab="All" key="0" />
            <TabPane tab="Approval" key="1" />
            <TabPane tab="Approved" key="2" />
            {/* <TabPane tab="Cancelled" key="3" /> */}
            <TabPane tab="Rejected" key="4" />
          </Tabs>
          <Row>
            <Col md={14} lg={14} sm={24} xs={24}>
              <div className='mt3 mb3'>
                <Button type='primary' onClick={() => this.handleDownloadSelectedRowToCSV()} loading={this.state.downloadLoading}>Download CSV</Button>
              </div>
            </Col>
          </Row>
          <Row className='commendation-header'>
            <Col md={14} lg={14} sm={24} >
              <div className='action-btn'>
                {
                  this.access('commendations', 'add') &&
                  <Button type="primary" shape="circle" icon={<FileAddOutlined />} size={'large'} title='Add' onClick={() => this.addModalToggle()} />
                }
              </div>
            </Col>
            <Col md={10} lg={10} sm={24} className='input-search'>
              <Search placeholder="Search Title, Description, Etc..." className='search' onChange={(e) => this.handleSearch(e.target.value)} style={{ width: 400 }} />
            </Col>
          </Row>
          <Row>
            <Table style={{ width: '100%' }} rowKey='id'
              rowSelection={rowSelection}
              loading={this.props.commendationsLoading || this.props.deleteCommendationLoading || this.props.updateCommendationLoading}
              dataSource={dataSource} columns={columns} pagination={false}
              key={(JSON.stringify(this.state.tableData))}
            />
            <Row style={{ marginTop: 30, width: '100%' }}>
              <Col md={24} lg={24} sm={24} xs={24} align="right">
                <Pagination defaultCurrent={this.state.page} onChange={(page, limit) => this.onChangePagination(page, limit)} total={this.props.commendationsData.total} pageSize={this.state.limit} />
              </Col>
            </Row>
          </Row>
        </Layout.Content>
        {
          this.state.isAddModalOpen &&
          <AddModal
            visible={this.state.isAddModalOpen}
            onCancel={this.addModalToggle}
          />
        }
        {
          this.state.isEditModalOpen &&
          <EditModal
            visible={this.state.isEditModalOpen}
            selectedRow={this.state.selectedRow}
            onCancel={this.editModalToggle}
          />
        }
      </Layout>
    )
  }
}

function mapStateToProps(state) {
  return {
    commendationLoading: state.admin.commendations.commendationLoading,
    commendationSuccess: state.admin.commendations.commendationSuccess,
    updateCommendationSuccess: state.admin.commendations.updateCommendationSuccess,
    deleteCommendationSuccess: state.admin.commendations.deleteCommendationSuccess,
    commendationsSuccess: state.admin.commendations.commendationsSuccess,
    commendationsData: state.admin.commendations.commendationsData,
    commendationsLoading: state.admin.commendations.commendationsLoading,
    deleteCommendationLoading: state.admin.commendations.deleteCommendationLoading,
    updateCommendationLoading: state.admin.commendations.updateCommendationLoading,
    adminData: state.admin.utilities.adminData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadCommendation: (status, pagination) => dispatch(loadCommendation(status, pagination)),
    onDeleteCommendation: (id) => dispatch(deleteCommendation(id)),
    onUpdateStatus: (data) => dispatch(updateCommendation(data)),
    onLoadSelectedRowCommendation: (selectedKeys) => dispatch(loadSelectedRowCommendation(selectedKeys))
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Commendations))
